export default "__VITE_ASSET__BGesWxy9__"